import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Image, polymorphicFactory, useProps } from "@coveord/plasma-mantine";
import loadingSpinnerGif from "../../images/coveo-spinner.gif";
import notAvailableSvg from "../../images/not-available.svg";
import notFoundSvg from "../../images/not-found.svg";
import noContentSvg from "../../images/no-content.svg";
import { useEmptyStateContext } from "./EmptyStateContext.js";
var defaultProps = {
    illustration: "not-found"
};
var emptyStateIllustrations = {
    "no-content": noContentSvg,
    "not-available": notAvailableSvg,
    "not-found": notFoundSvg,
    "coveo-spinner": loadingSpinnerGif
};
export var EmptyStateImage = polymorphicFactory(function(_props, ref) {
    var ctx = useEmptyStateContext();
    var _ref = useProps("EmptyStateImage", defaultProps, _props), style = _ref.style, className = _ref.className, classNames = _ref.classNames, styles = _ref.styles, unstyled = _ref.unstyled, illustration = _ref.illustration, others = _object_without_properties(_ref, [
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "illustration"
    ]);
    return /*#__PURE__*/ _jsx(Image, _object_spread({
        ref: ref,
        src: illustration ? emptyStateIllustrations[illustration] : undefined,
        fit: "cover"
    }, ctx.getStyles("image", {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others));
});

//# sourceMappingURL=EmptyStateImage.js.map